import React from 'react';
import { CheckCircle2Icon, MailIcon, AlertCircleIcon, PartyPopperIcon, HeartIcon } from 'lucide-react';
const NAVY = '#142D52';
const CORAL = '#F05B56';
const TEAL = '#00AFAA';
const MINT = '#F0FAF9';
export function BedanktAankoopPage() {
  return <div className="min-h-screen w-full font-sans" style={{
    backgroundColor: MINT,
    color: NAVY,
    fontFamily: "'Sen', sans-serif"
  }} data-id="element-1249" data-mp="27wy22fkkckv7">
      {/* Logo bar */}
      <nav className="w-full bg-white border-b border-gray-100 py-4 px-6" data-id="element-1250" data-mp="1g61pzh6buk8z">
        <div className="max-w-5xl mx-auto flex justify-center" data-id="element-1251" data-mp="1k9zte42oqh7u">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6YKzftRpGkz4jKTtn8FQxB/Logo_Stressless_Dogs_%288%29_%284%29.png" alt="Stressless Dogs" className="h-10 object-contain" data-id="element-1252" data-mp="1p8ayk1i1c3jq" />
        </div>
      </nav>

      {/* Hero */}
      <section className="max-w-3xl mx-auto px-4 pt-12 pb-8 text-center" data-id="element-1253" data-mp="11ip4fsgiseil">
        <div className="inline-flex items-center justify-center w-20 h-20 rounded-full mb-6 shadow-lg" style={{
        backgroundColor: TEAL
      }} data-id="element-1254" data-mp="11gm2qb608wy1">
          <CheckCircle2Icon className="w-12 h-12 text-white" strokeWidth={2.5} data-id="element-1255" data-mp="3vk3scpeqhffr" />
        </div>
        <p className="text-sm font-bold uppercase tracking-widest mb-3" style={{
        color: CORAL
      }} data-id="element-1256" data-mp="3lsfua5no905b">
          Aankoop geslaagd
        </p>
        <h1 className="text-4xl md:text-5xl font-extrabold leading-tight mb-4 flex items-center justify-center gap-3 flex-wrap" style={{
        color: NAVY
      }} data-id="element-1257" data-mp="3bu01zzcwrku8">
          Yes! Gefeliciteerd
          <PartyPopperIcon className="w-9 h-9 md:w-11 md:h-11" style={{
          color: CORAL
        }} data-id="element-1258" data-mp="32u3hm9xjx84z" />
        </h1>
        <p className="text-xl md:text-2xl font-medium mb-2" style={{
        color: NAVY
      }} data-id="element-1259" data-mp="111ywbhak5938">
          Je aankoop is geslaagd
        </p>
      </section>

      {/* Personal message from Amee */}
      <section className="max-w-3xl mx-auto px-4 pb-10" data-id="element-1260" data-mp="1oybzm1ergbx3">
        <div className="bg-white rounded-2xl shadow-md p-6 md:p-10" data-id="element-1261" data-mp="1b5vt2qmnhvrf">
          <div className="flex flex-col sm:flex-row items-center sm:items-start gap-5 mb-6" data-id="element-1262" data-mp="1b7qfyahhfxy5">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/kJ5b6tBbH8hDNt52JG84mT/Scherm%C2%ADafbeelding_2025-08-15_om_15.44.02.png" alt="Amee de Bruijn" className="w-20 h-20 md:w-24 md:h-24 rounded-full object-cover flex-shrink-0 ring-4 ring-white shadow-md" data-id="element-1263" data-mp="1g5i36r76mvw0" />
            <div className="text-center sm:text-left" data-id="element-1264" data-mp="1tyr9uk3qx3au">
              <p className="font-bold text-lg" style={{
              color: NAVY
            }} data-id="element-1265" data-mp="1yu6mj8q0ot5o">
                Een persoonlijk berichtje van Amee
              </p>
              <p className="text-gray-500 text-sm" data-id="element-1266" data-mp="nhmcq487i07o">Oprichter Stressless Dogs</p>
            </div>
          </div>

          <div className="text-base md:text-lg leading-relaxed space-y-4" style={{
          color: NAVY
        }} data-id="element-1267" data-mp="fymtpzonqaou">
            <p data-id="element-1268" data-mp="ow6xpgdwml35">Wauw, wat ben ik blij dat je deze stap zet! 🙌</p>
            <p data-id="element-1269" data-mp="jyn9poremty0">
              Wat ontzettend goed dat je investeert in het{' '}
              <span className="font-bold" data-id="element-1270" data-mp="3se6vy3tnrc3k">geluk van je hond</span> en in jullie
              onderlinge band - daar mag je als hondeneigenaar écht trots op
              zijn.
            </p>
            <p className="italic font-medium" style={{
            color: CORAL
          }} data-id="element-1271" data-mp="3oased8q2mno0">
              *applausje voor jezelf* 👏
            </p>
            <p data-id="element-1272" data-mp="162rd19c078g">
              De meeste baasjes blijven hangen in oude trainingen en commando's.
              Jij kiest voor iets anders: écht communiceren met je hond. En dat
              is precies waar de mooiste banden ontstaan.
            </p>
            <p className="flex items-center gap-2 font-semibold" data-id="element-1273" data-mp="3icebl8q8ucxl">
              Liefs, Amee{' '}
              <HeartIcon className="w-5 h-5" style={{
              color: CORAL,
              fill: CORAL
            }} data-id="element-1274" data-mp="3nbhhswhymp75" />
            </p>
          </div>
        </div>
      </section>

      {/* Next steps */}
      <section className="max-w-3xl mx-auto px-4 pb-10" data-id="element-1275" data-mp="4wp0tmd0ooe6">
        <h2 className="text-2xl md:text-3xl font-bold mb-6 text-center" style={{
        color: NAVY
      }} data-id="element-1276" data-mp="4w6z4a7l5hyv">
          Wat gebeurt er nu?
        </h2>

        <div className="space-y-4" data-id="element-1277" data-mp="ev5w2viznp61">
          {/* Step 1 */}
          <div className="bg-white rounded-2xl shadow-sm p-5 md:p-6 flex gap-4 items-start" data-id="element-1278" data-mp="jtzbithu5q8u">
            <div className="flex-shrink-0 w-12 h-12 rounded-full flex items-center justify-center text-white font-bold text-lg" style={{
            backgroundColor: TEAL
          }} data-id="element-1279" data-mp="2gmiyndxhhkyx">
              <MailIcon className="w-6 h-6" data-id="element-1280" data-mp="12rj0jiyxgy1h" />
            </div>
            <div className="flex-1" data-id="element-1281" data-mp="xypu8qnt9hna">
              <p className="font-bold text-lg mb-1" style={{
              color: NAVY
            }} data-id="element-1282" data-mp="xxol4rqcv587">
                Check je mailbox
              </p>
              <p className="text-gray-700 leading-relaxed" data-id="element-1283" data-mp="p0e74ym5l1zl">
                Binnen enkele minuten ontvang je een bevestigingsmail met je{' '}
                <span className="font-semibold" data-id="element-1284" data-mp="1hmp6y71xqyvc">inloggegevens</span> en alle
                informatie om direct te kunnen starten.
              </p>
            </div>
          </div>

          {/* Step 2 - warning */}
          <div className="rounded-2xl p-5 md:p-6 flex gap-4 items-start border-2" style={{
          backgroundColor: '#FFF7ED',
          borderColor: CORAL
        }} data-id="element-1285" data-mp="17pucq0cp3kmv">
            <div className="flex-shrink-0 w-12 h-12 rounded-full flex items-center justify-center text-white" style={{
            backgroundColor: CORAL
          }} data-id="element-1286" data-mp="3sei8blm8bdmr">
              <AlertCircleIcon className="w-6 h-6" data-id="element-1287" data-mp="2pcrdivtyzky" />
            </div>
            <div className="flex-1" data-id="element-1288" data-mp="3kupm2q2xjgqj">
              <p className="font-bold text-lg mb-1" style={{
              color: NAVY
            }} data-id="element-1289" data-mp="3kxvbk6fh0kms">
                Belangrijk: niets ontvangen na 10 minuten?
              </p>
              <p className="text-gray-700 leading-relaxed" data-id="element-1290" data-mp="3fx7kjkr8s3sk">
                Check dan even je{' '}
                <span className="font-semibold" data-id="element-1291" data-mp="325sxn2u7rig8">spam- of reclamefolder</span>.
                Mailtjes belanden daar soms onbedoeld in.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Support */}
      <section className="max-w-3xl mx-auto px-4 pb-16" data-id="element-1292" data-mp="2s7lmj0mlvum5">
        <div className="rounded-2xl p-6 md:p-8 text-center" style={{
        backgroundColor: NAVY
      }} data-id="element-1293" data-mp="2x6pu5mtvtkad">
          <p className="text-white/80 mb-2 text-sm uppercase tracking-wider font-semibold" data-id="element-1294" data-mp="2dkmwna3ed89j">
            Hulp nodig?
          </p>
          <h3 className="text-white text-xl md:text-2xl font-bold mb-3" data-id="element-1295" data-mp="2nikijqxsasyz">
            Vragen of technische problemen?
          </h3>
          <p className="text-white/90 mb-5 leading-relaxed" data-id="element-1296" data-mp="2ij7vp66wxlwe">
            Stuur me gerust een mailtje - ik help je graag persoonlijk verder.
          </p>
          <a href="mailto:Amee@Stresslessdogs.nl" className="inline-flex items-center gap-2 bg-white font-bold px-6 py-3 rounded-full transition-transform hover:scale-105 shadow-lg" style={{
          color: NAVY
        }} data-id="element-1297" data-mp="2wgw6fl79ncnq">
            <MailIcon className="w-5 h-5" data-id="element-1298" data-mp="31aqybbx0yxxw" />
            Amee@Stresslessdogs.nl
          </a>
        </div>
      </section>

      {/* Footer */}
      <footer className="border-t border-gray-200 bg-white py-8 px-4" data-id="element-1299" data-mp="3b8evs9m0mjjr">
        <div className="max-w-5xl mx-auto text-center text-sm text-gray-500" data-id="element-1300" data-mp="3b626tchub8x7">
          <p data-id="element-1301" data-mp="lh72gvbe7t0d">© 2025 Stressless Dogs. Voor liefdevolle hondenbaasjes.</p>
        </div>
      </footer>
    </div>;
}